<template>
  <div class="case-box">
    <div v-for="(v, i) in cases" :key="i">
      <div class="top-line">
        <!-- <p>{{v.title}}</p> -->
        <h1 class="h1">病例标题：{{v.title}}</h1>
        <div class="btns" v-if="isEdit">
          <span v-if="i!==0" @click="moveUp(v, i)">上移</span>
          <span v-if="i+1<cases.length" @click="moveDown(v, i)">下移</span>
          <span class="edit" @click="handleEdit(v.studyId)">修改</span>
        </div>
      </div>
      <div class="con">
        <div class="con-1">
          <p class="p">
            <!-- <i>影像资源：</i> -->
            <!-- <span class="span" v-for="val in v.studyUploadList" :key="val.studyUuid">
              {{val.accessNo}}
              <span class="btn">查看影像</span>
              <el-button size="mini"  type="primary" @click="getdimage(val.url)">预览</el-button>
            </span> -->
            <ul class="jc-list">
              <li v-for="val in v.studyUploadList" :key="val.studyUuid" @click="getdimage(val.url)">
                <div>
                  <h2><img src="../../../assets/images/yx.png" class="account" alt />检查编号</h2>
                  <p>{{val.accessNo}}</p>
                </div>
                <div><i class="el-icon-arrow-right" style="color:rgba(0, 0, 0, 0.4);font-weight:600"></i></div>
              </li>
            </ul>
          </p>
        </div>
      </div>
      <div class="con">
        <h1 class="h1">患者申请单</h1>
        <div class="con-1">
          <p class="p">
            <i>基本信息：</i><span>患者</span>
            <span>{{v.patGender}}</span> <span>{{v.patAge}}</span>
          </p>
        </div>
        <div><p class="p long"><i>检查部位：</i><span>{{v.checkPoint}}</span></p></div>
        <div><p class="p long"><i>临床诊断：</i><span>{{v.clinic}}</span></p></div>
        <div><p class="p long"><i>检查目的：</i><span>{{v.studyDest}}</span></p></div>
        <div><p class="p long"><i>病例摘要：</i><span>{{v.clinicDiagnosis}}</span></p></div>
      </div>
      <div class="con">
        <h1 class="h1">报告详情单</h1>
        <div class="con-2">
          <p class="p"><i>检查类型：</i><span>{{v.modality}}</span></p>
          <p class="p"><i>检查项目：</i><span>{{v.examItem}}</span></p>
        </div>
        <div><p class="p"><i class="i-diy-width">影像学表现：</i><span>{{v.finding}}</span></p></div>
        <div><p class="p"><i class="i-diy-width">诊断：</i><span>{{v.conclusion}}</span></p></div>
        <div><p class="p"><i class="i-diy-width">影像学表现关键字：</i><span>{{v.findingKeys}}</span></p></div>
        <div><p class="p"><i class="i-diy-width">诊断关键字：</i><span>{{v.conclusionKeys}}</span></p></div>
      </div>
      <div class="con">
        <h1 class="h1">病理报告</h1>
        <div><p class="p"><i class="i-diy-width">病理诊断：</i><span>{{v.caseDiagnosis}}</span></p></div>
        <div><p class="p"><i class="i-diy-width">病理解析：</i><span>{{v.caseAnalysis}}</span></p></div>
      </div>
      <div class="border"></div>
    </div>
  </div>
</template>

<script>
import { packgeServer } from '@/api/api'
export default {
  props: {
    cases: {
      type: Array,
      require: false
    },
    isEdit: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    moveUp (item, index) {
      const json = [
        {studyId: item.studyId, sort: this.cases[index - 1].sort === item.sort ? this.cases[index - 1].sort + 5 : this.cases[index - 1].sort},
        {studyId: this.cases[index - 1].studyId, sort: item.sort}
      ]
      packgeServer.caseSort(JSON.stringify(json)).then(res => {
        const {code, data, message} = res
        if (code === '0') {
          this.$emit('update')
        }
      }).catch((error) => {
        this.$message.error(error)
      })
    },
    moveDown (item, index) {
      const json = [
        {studyId: item.studyId, sort: this.cases[index + 1].sort === item.sort ? this.cases[index + 1].sort - 5 : this.cases[index + 1].sort},
        {studyId: this.cases[index + 1].studyId, sort: item.sort}
      ]
      packgeServer.caseSort(JSON.stringify(json)).then(res => {
        const {code, data, message} = res
        if (code === '0') {
          this.$emit('update')
        }
      }).catch((error) => {
        this.$message.error(error)
      })
    },
    // 查看影像
    getdimage (url) {
      window.open(this.$dimage + url, '_blank')
    },
    handleEdit (id) {
      let rourteUrl = this.$router.resolve({
        path: '/resource/addcaseIndex',
        query: {id}
      });
      window.open(rourteUrl.href, '_blank')
    },
  }
}
</script>

<style lang='scss' scoped>
.case-box {
  margin-top: 10px;
  line-height: 30px;
  .top-line {
    position: relative;
    text-align: left;
    p {
      display: inline-block;
      width: calc(100% - 125px);
      font-size: 16px;
      font-weight: 600;
    }
    .h1{
      color: #333;
      font-size: 15px;
      margin-bottom: 10px;
    }
    .btns {
      display: inline-block;
      position: absolute;
      right: 0;
      span {
        padding: 0 5px;
        color: #409eff;
        cursor: pointer;
      }
      .edit {
        color: #95d1a3;
      }
    }
  }
  .con {
    text-align: left;
    line-height: 28px;
    .h1{
      color: #333;
      font-size: 15px;
      margin-bottom: 6px;
      margin-top: 10px;
    }
    .con-1, .con-2{
      display: flex;
      justify-content: space-between;
      p {
        display: inline-block;
        .jc-list {
          display: flex;
          gap: 12px 16px;
          flex-wrap: wrap;
          margin-top: 8px;
          margin-bottom: 12px;
          li {
            width: 240px;
            height: 72px;
            padding: 10px 24px;
            background: #FAFBFE;
            border-radius: 16px;
            border: 2px solid rgba(186, 209, 246, 0.08);
            display: flex;
            align-items: center;
            justify-content: space-between;
            cursor: pointer;
            h2 {
              margin-bottom: 4px;
              font-size: 16px;
              color: #3D3D3D;
              img {
                width: 24px;
                height: 24px;
                vertical-align: middle;
                margin-right: 8px;
              }
            }
            p {
              color: #3D3D3D;
            }
          }
        }
        .span {
          display: inline-block;
          margin-right: 12px;
          margin-bottom: 8px;
          .btn {
            border-radius: 12px;
            cursor: pointer;
            border: 1px solid #0052D9;
            color: #0052D9;
            padding: 0px 10px;
          }
        }
      }
    }
    .con-2{
      justify-content: start;
      .p{
        width: 30%;
      }
      .p:last-of-type {
        width: calc(100% - 30%);
      }
    }
    .p{
      display: flex;
      justify-content: start;
      i{
        display: inline-block;
        color: #3D3D3D;
      }
      span{
        display: inline-block;
        color: #3D3D3D;
      }
      .i-diy-width{
        width: 138px;
        /* text-align: right; */
      }
      .i-diy-width +span{
        width: calc(100% - 150px);
      }
    }
    .long{
      position: relative;
      padding-left: 78px;
      min-height: 22px;
      i{
        position: absolute;
        left: 0;
      }
    }
  }
  .border {
    width: 100%;
    height: 1px;
    margin: 10px 0;
    background-color: #ccc;
  }
}
</style>


// WEBPACK FOOTER //
// src/views/coursePackage/components/casebox.vue